import React from "react";
import Placeholder from "./Placeholder";
import SimpleCentered from "./SimpleCentered";
import Content from "./Content";
import ContentCentered from "./ContentCentered";
import ContentCtaCentered from "./ContentCtaCentered";
import TestimonialsWithBackgroundImage from "./TestimonialsWithBackgroundImage"
import SplitWithImagesSlider from './SplitWithImagesSlider'
import ContentSplitFourColumn from "./ContentSplitFourColumn";
import LogoCloudsSlider from "./LogoCloudsSlider"
import FullWidthImage from "./FullWidthImage"
import FourByTwoGridOnBrand from "./FourByTwoGridOnBrand"
import CarouselWithIntro from "./CarouselWithIntro"
import PricingWithToggle from './Pricing/PricingWithToggle';
import PricingTable from "./PricingTable";
import HtmlBlock from "./HtmlBlock";
import PricingWithoutToggle from './Pricing/PricingWithoutToggle';
import FeaturedPostTypes from "./FeaturedPostTypes"
import ThreeColumnCards from "./ThreeColumnCards"
import ListingThreeColumnCards from "./ListingThreeColumnCards"
import ListingThreeColumnCardsCustom from "./ListingThreeColumnCardsCustom"
import WithLargeImages from "./WithLargeImages"
import CookieContent from "./CookieContent";

/* Marketing / PageSections / ContentSections */
import Centered from "./Marketing/PageSections/ContentSections/Centered";
import SimpleThreeColumn from "./SimpleThreeColumn";
import SplitWithImage from "./Marketing/PageSections/ContentSections/SplitWithImage";
import SplitWithImageTeal from "./Marketing/PageSections/ContentSections/SplitWithImageTeal";
import SplitWithImageSmall from "./Marketing/PageSections/ContentSections/SplitWithImageSmall";
import TwoColumns from "./Marketing/PageSections/ContentSections/TwoColumns";
import TwoColumnsWithImage from "./Marketing/PageSections/ContentSections/TwoColumnsWithImage";
import TwoColumnsWithTestimonial from "./Marketing/PageSections/ContentSections/TwoColumnsWithTestimonial";
import WithTestimonialAndStats from "./Marketing/PageSections/ContentSections/WithTestimonialAndStats";
import Stat from "./Marketing/PageSections/ContentSections/Stat";

/* Marketing / PageSections / Contact Sections */
import ContactCentered from "./Marketing/PageSections/ContactSections/Centered";

/* Marketing / PageSections / CTA Sections */
import BrandPanelOverlappingImage from "./Marketing/PageSections/CTASections/brand-panel-with-overlapping-image";
import BrandPanelAppScreenshot from "./Marketing/PageSections/CTASections/brand-panel-with-app-screenshot";
import SimpleJustified from "./Marketing/PageSections/CTASections/simple-justified";

/* Marketing / PageSections / FAQs */
import OffsetSupportingText from "./Marketing/PageSections/FAQs/offset-supporting-text";

/* Marketing / PageSections / Testimonials */
import TestimonialsSimpleCentered from "./Marketing/PageSections/Testimonials/SimpleCentered";
import TestimonialSideBySide from "./Marketing/PageSections/Testimonials/TestimonialSideBySide";
import SimpleCenterBranded from "./Marketing/PageSections/Testimonials/SimpleCenterBranded"

/* Marketing / Feedback / 404 Pages */
import Simple404 from "./Marketing/Feedback/404Pages/simple";

/* TBB */
import CenteredAccordion from "./TBB/Accordions/centered-accordion";
import Hero from "./TBB/Heros/Hero";
import HeroSlimline from "./TBB/Heros/HeroSlimline";
import HeroCustom from "./TBB/Heros/HeroCustom";

/* Custom */
import GoogleMap from "./Custom/GoogleMap";
import Video from "./Custom/Video";
import Calendly from "./Calendly";
import CustomHtml from "./CustomHtml/CustomHtml";

import Form from "./Form"
import TextInput from "./Forms/Components/TextInput"
import EmailInput from "./Forms/Components/EmailInput";
import TextAreaInput from "./Forms/Components/TextAreaInput";
import FileInput from "./Forms/Components/FileInput";
import NumberInput from "./Forms/Components/NumberInput";
import SelectInput from "./Forms/Components/SelectInput";

import CustomJSBlock from './CustomJSBlock';

const Components = {
  "hero": Hero,
  "hero-slimline": HeroSlimline,
  "hero-custom": HeroCustom,
  "simple-centered": SimpleCentered,
  /* Marketing / PageSections / ContentSections */
  "split-with-image": SplitWithImage,
  "split-with-image-teal": SplitWithImageTeal,
  "split-with-image-small": SplitWithImageSmall,
  centered: Centered,
  "two-columns": TwoColumns,
  "two-columns-with-image": TwoColumnsWithImage,
  "two-columns-with-testimonial": TwoColumnsWithTestimonial,
  "simple-three-column": SimpleThreeColumn,
  "with-testimonial-and-stats": WithTestimonialAndStats,
  stat: Stat,
  /* Marketing / Feedback / 404 Pages */
  "simple-404" : Simple404,
  /* Marketing / PageSections / CTA Sections */
  "brand-panel-overlapping-image": BrandPanelOverlappingImage,
  "brand-panel-app-screenshot": BrandPanelAppScreenshot,
  "simple-justified": SimpleJustified,
  /* Marketing / PageSections / FAQs */
  "offset-with-supporting-text": OffsetSupportingText,
  /* Marketing / PageSections / Contact Sections */
  "contact-centered": ContactCentered,
  /* Marketing / PageSections / Testimonials */
  "testimonial-simple-centered": TestimonialsSimpleCentered,
  /* TBB */
  "centered-accordion": CenteredAccordion,
  /* Custom */
  "video": Video,
  //"google-map":GoogleMap,
  "content":Content,
  "content-split-four-column": ContentSplitFourColumn,
  "content-centered":ContentCentered,
  "content-cta-centered":ContentCtaCentered,
  "testimonials-with-background-image":TestimonialsWithBackgroundImage,
  "logo-clouds-slider":LogoCloudsSlider,
  "split-with-images-slider": SplitWithImagesSlider,
  "full-width-image": FullWidthImage,
  "testimonial-side-by-side": TestimonialSideBySide,
  "four-by-two-grid-on-brand": FourByTwoGridOnBrand,
  "carousel-with-intro": CarouselWithIntro,
  "pricing-with-toggle": PricingWithToggle,
  "pricing-table": PricingTable,
  "html-block": HtmlBlock,
  "pricing-without-toggle": PricingWithoutToggle,
  "simple-center-branded": SimpleCenterBranded,
  "featured-post-types": FeaturedPostTypes,
  "three-column-cards": ThreeColumnCards,
  "listing-three-column-cards": ListingThreeColumnCards,
  "listing-three-column-cards-custom": ListingThreeColumnCardsCustom,
  "with-large-images": WithLargeImages,
  "form": Form,
  "text-input": TextInput,
  "email-input": EmailInput,
  "textarea-input": TextAreaInput,
  "file-input": FileInput,
  "number-input": NumberInput,
  "select-input": SelectInput,
  "calendly": Calendly,
  "cookie-content": CookieContent,
  "custom-html": CustomHtml,
  "CustomJSBlock": CustomJSBlock
  
};

const DynamicComponent = ({ blok }) => {

  if (blok.component == "CustomJSBlock") {
    return <CustomJSBlock customJS={blok.customJS} />;
  }

  if (typeof Components[blok.component] !== "undefined") {
    const Component = Components[blok.component];
    return <Component blok={blok} key={blok._uid} />;
  }



  return blok.component ? <Placeholder componentName={blok.component} /> : null;
};

export default DynamicComponent;
